// Generate a timestamp-based version
export const APP_VERSION = new Date().getTime();

// Or use a static version that you increment with each deployment
// export const APP_VERSION = '1.0.0';

export const getVersionedUrl = (url) => {
    return `${url}?v=${APP_VERSION}`;
};